import { cn } from "../lib/utils";

const STYLES = {
  // sponsorship statuses
  closed:      "bg-emerald-500/15 text-emerald-400 border-emerald-500/20",
  negotiating: "bg-amber-500/15 text-amber-400 border-amber-500/20",
  prospect:    "bg-zinc-500/15 text-zinc-400 border-zinc-500/20",
  // backstage statuses
  sold:        "bg-emerald-500/15 text-emerald-400 border-emerald-500/20",
  open:        "bg-zinc-500/15 text-zinc-400 border-zinc-500/20",
};

export default function StatusPill({ status, "data-testid": testId }) {
  const cls = STYLES[status] || STYLES.prospect;
  return (
    <span
      data-testid={testId}
      className={cn(
        "inline-flex items-center px-2 py-0.5 text-[10px] font-medium uppercase tracking-[0.18em] border rounded-sm",
        cls
      )}
    >
      {status}
    </span>
  );
}
